import { render } from "./TopCoursesSection.vue?vue&type=template&id=4f9b51ba&scoped=true"
import script from "./TopCoursesSection.vue?vue&type=script&lang=js"
export * from "./TopCoursesSection.vue?vue&type=script&lang=js"

import "./TopCoursesSection.vue?vue&type=style&index=0&id=4f9b51ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9b51ba"]])

export default __exports__